export default __webpack_public_path__ + "static/ABA_2020-Finalist_Customer Service of the Year-b908b21839708570e568bed7634109e0.png";